import { StyledCopyAssistDropdown } from 'modules/ai/copyAssist/components/dropdown/styles';
import styled, { css } from 'styled-components';
import { Delete } from 'ui/icons';
import { Announcement } from 'ui/announcement';
import { caption, colors, fontWeights, heading4, spacing, zIndex } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p30: pxToRem(30),
  p528: pxToRem(528),
  p648: pxToRem(648),
};

type ContainerProp = {
  /** Is the overlay enabled over the takeover */
  isOverlayEnable: boolean;
};

export const Container = styled.div<ContainerProp>`
  padding: ${spacing.plusHalf} ${spacing.double};
  display: flex;
  flex-direction: row;
  gap: ${customSpacing.p30};

  @media screen and (max-width: 1020px) {
    flex-direction: column;
    gap: ${spacing.plusHalf};
  }

  /**
  * Styles which will make the copy assist dropdown look disabled
  * By adding an overlay over the dropdown option
  * */
  ${(props) =>
    props.isOverlayEnable &&
    css`
      ${StyledCopyAssistDropdown} {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.5);
          z-index: ${zIndex.toast};
        }
      }
    `}
`;

export const ExperimentConfigurationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  min-width: ${customSpacing.p528};
  max-width: ${customSpacing.p648};
  width: 100%;

  @media screen and (max-width: 1020px) {
    min-width: auto;
    max-width: 100%;
  }
`;

export const ContentSection = styled.div`
  width: 100%;
`;

export const StyledFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.base};
`;

export const StyledCampaignHeader = styled.div`
  ${heading4}
  font-weight: ${fontWeights.bold};
  color: ${colors.white};
`;

export const UnsavedChangesMessage = styled.div`
  ${caption}
  display: inline-flex;
  align-items: center;
  gap: ${spacing.quarter};
  color: ${colors.textSecondary};
`;

export const StyledAnnouncement = styled(Announcement)`
  margin-bottom: ${spacing.half};
`;

export const StyledDeleteIcon = styled(Delete)`
  width: ${spacing.base};
  height: ${spacing.base};
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0); /* Transparent background */
  z-index: ${zIndex.toast};
`;
